// Traduções para os 7 idiomas
export const translations = {
  pt: {
    nav: {
      home: "Início",
      team: "Equipa",
      services: "Serviços",
      contact: "Contato",
      predimed: "Imóveis"
    },
    hero: {
      title: "Miguel Ângelo",
      subtitle: "Gestor de Rede",
      description: "Especialista em gestão de redes e desenvolvimento de equipas, combinando estratégia, liderança e Inteligência Artificial para acelerar crescimento e maximizar resultados. Ajudo pessoas e negócios a atingir o seu máximo potencial com um acompanhamento próximo e orientado para a performance.",
      cta: "Conhecer a Equipa",
      contact: "Entrar em Contato"
    },
    apexTeam: {
      title: "Apex Team",
      subtitle: "A equipa de alta performance ao seu lado",
      description: "Profissionais dedicados ao seu crescimento. Estratégia, liderança e execução orientada para resultados.",
      roleLabel: "Função",
      contactMember: "Contactar"
    },
    predimedInvite: {
      title: "À procura de imóveis?",
      description: "Aceda a mais de 8.000 imóveis em Portugal através da rede Predimed.",
      cta: "Visitar Predimed.pt"
    },
    services: {
      title: "Serviços",
      subtitle: "Soluções completas para o mercado imobiliário",
      items: [
        {
          id: 1,
          title: "Compra & Venda de Imóveis",
          description: "Seleção de propriedades de qualidade e acompanhamento personalizado em todas as etapas do processo."
        },
        {
          id: 2,
          title: "Construção de Casas",
          description: "Projectos arquitectónicos personalizados e construção de moradias com materiais de qualidade."
        },
        {
          id: 3,
          title: "Decoração de Interiores",
          description: "Transformamos espaços em ambientes únicos e funcionais com designers especializados."
        },
        {
          id: 4,
          title: "Remodelações & Renovações",
          description: "Modernização e valorização de propriedades com qualidade e atenção aos detalhes."
        },
        {
          id: 5,
          title: "Gestão de Mudanças",
          description: "Serviço completo de mudança e organização para tornar a sua transição simples e eficiente."
        },
        {
          id: 6,
          title: "Consultoria Jurídica",
          description: "Parceria com escritórios de advogados especializados em direito imobiliário para total segurança."
        }
      ]
    },
    about: {
      title: "Quem é Miguel Ângelo?",
      description: "Gestor de rede com mais de 8 anos de experiência no mercado imobiliário. Especializado em conectar clientes às melhores oportunidades, ofereço um serviço personalizado e profissional em todo o território nacional.",
      experience: "Anos de Experiência",
      network: "Rede Nacional"
    },
    differentials: {
      title: "O Que Me Distingue",
      items: [
        {
          id: 1,
          title: "Rede Nacional Predimed",
          description: "Acesso a uma ampla rede de propriedades e compradores qualificados em todo o país através da rede Predimed."
        },
        {
          id: 2,
          title: "Serviço Personalizado",
          description: "Acompanhamento completo desde a procura até à entrega das chaves, incluindo todos os serviços complementares."
        },
        {
          id: 3,
          title: "Marketing Profissional",
          description: "Fotografia profissional, vídeos, tours virtuais e campanhas de marketing digital para destacar o seu imóvel."
        },
        {
          id: 4,
          title: "Experiência Comprovada",
          description: "Mais de 8 anos de experiência no mercado imobiliário com resultados consistentes."
        },
        {
          id: 5,
          title: "Equipa Multidisciplinar",
          description: "Parcerias com arquitectos, designers, advogados e construtores de referência no mercado."
        },
        {
          id: 6,
          title: "Virtual Staging",
          description: "Técnicas de staging virtual para apresentar o potencial máximo dos imóveis aos compradores."
        }
      ]
    },
    properties: {
      title: "Imóveis Disponíveis",
      subtitle: "Seleção de propriedades de qualidade",
      specialMessage: "Trabalhar comigo, qualquer imóvel que goste, mesmo em outras agências, ele pode ser seu",
      viewAll: "Ver Portfólio Completo",
      bedrooms: "quartos",
      bathrooms: "casas de banho",
      area: "área",
      reference: "Ref"
    },
    featuredProperty: {
      badge: "OPORTUNIDADE DESTAQUE",
      photos: "Fotos",
      bedrooms: "Quartos",
      bathrooms: "WC's",
      area: "m²",
      equipment: "Equipamentos:",
      brutArea: "Área Bruta:",
      landArea: "Terreno:",
      year: "Ano:",
      energyCert: "Certificado Energético:",
      requestInfo: "Solicitar Informação",
      viewOnPredimed: "Ver no Predimed",
      viewFloorPlans: "Ver Plantas",
      makeOffer: "Fazer Proposta",
      floorPlansTitle: "Plantas da Moradia",
      floorPlansSubtitle: "Plantas técnicas detalhadas de todos os pisos",
      floorPlan: "Planta",
      of: "de",
      offerModalTitle: "Fazer Proposta",
      askingPrice: "Preço Pedido:",
      yourOffer: "Valor da Sua Proposta",
      offerPlaceholder: "Digite o valor da sua proposta",
      offerAnalysis: "Análise da Proposta",
      difference: "Diferença",
      percentage: "Percentagem",
      summary: "Resumo",
      cancel: "Cancelar",
      sendOffer: "Enviar Proposta",
      disclaimer: "* Ao enviar a proposta, será redirecionado para o formulário de contato onde poderá finalizar o pedido.",
      offerTooLow: "Proposta muito abaixo do valor pedido. Pode não ser considerada.",
      offerLow: "Proposta baixa. Requer negociação significativa.",
      offerReasonable: "Proposta razoável. O vendedor pode negociar.",
      offerExcellent: "Excelente proposta! Muito provável ser aceite."
    },
    contact: {
      title: "Vamos Conversar sobre o Seu Projecto?",
      subtitle: "Entre em contacto para uma consulta personalizada",
      phone: "Telefone",
      email: "Email",
      location: "Localização",
      form: {
        name: "Nome",
        email: "Email",
        phone: "Telefone",
        country: "País",
        city: "Cidade",
        interest: "Interesse",
        buy: "COMPRA",
        sell: "VENDA",
        message: "Mensagem",
        submit: "Enviar Mensagem",
        success: "Mensagem enviada com sucesso!",
        successDescription: "Entraremos em contacto em breve!",
        error: "Erro ao enviar mensagem. Tente novamente."
      }
    },
    footer: {
      description: "Gestor de Rede especializado no mercado imobiliário com foco em propriedades de qualidade.",
      contact: "Contacto",
      properties: "Imóveis",
      viewAllPredimed: "Ver portfólio completo Predimed",
      accessInfo: "Acesso a +8000 imóveis em Portugal",
      designed: "Concebido para o Mercado Imobiliário",
      rights: "Todos os direitos reservados"
    },
    simulator: {
      title: "Simulador de Rede",
      subtitle: "Calcule os seus ganhos potenciais anuais",
      login: {
        title: "Simulador de Rede",
        restrictedAccess: "Acesso Restrito",
        password: "Password",
        passwordPlaceholder: "Digite a password",
        submit: "Aceder",
        errorMessage: "Password incorreta! Tente novamente."
      },
      config: {
        ownRevenue: "Sua Faturação Anual",
        ownRevenueLabel: "Faturação Própria (€/ano)",
        ownRevenueHelper: "Você ganha 80% desta faturação",
        networkConfig: "Configuração da Rede",
        people: "Pessoas",
        peoplePerLine: "Pessoas por linha",
        revenue: "Faturação (€)",
        level: "Nível",
        commission: "comissão",
        emptyLevel: "vazio",
        uniformRevenue: "Faturação uniforme para todos",
        individualRevenue: "Faturação individual por pessoa",
        person: "Pessoa"
      },
      pyramid: {
        title: "Visualização da Rede",
        you: "VOCÊ",
        youCommission: "80% comissão",
        totalPeople: "Total de Pessoas na Rede",
        peopleInNetwork: "Pessoas na sua rede"
      },
      calculate: "Calcular Ganhos",
      results: {
        title: "Ganhos Totais Anuais",
        perYear: "Por ano",
        perMonth: "/mês",
        breakdown: "Detalhamento",
        ownCommission: "Comissão Própria (80%)",
        networkCommissions: "Comissões da Rede:",
        networkTotal: "Total da Rede",
        networkSize: "Tamanho da Rede",
        peopleCount: "pessoas"
      }
    }
  },
  en: {
    nav: {
      home: "Home",
      team: "Team",
      services: "Services",
      contact: "Contact",
      predimed: "Properties"
    },
    hero: {
      title: "Miguel Ângelo",
      subtitle: "Network Manager",
      description: "Specialist in network management and team development, combining strategy, leadership and Artificial Intelligence to accelerate growth and maximize results. I help people and businesses reach their full potential through close, performance-driven guidance.",
      cta: "Meet the Team",
      contact: "Schedule Meeting"
    },
    apexTeam: {
      title: "Apex Team",
      subtitle: "The high-performance team by your side",
      description: "Professionals dedicated to your growth. Strategy, leadership and results-driven execution.",
      roleLabel: "Role",
      contactMember: "Contact"
    },
    predimedInvite: {
      title: "Looking for properties?",
      description: "Access more than 8,000 properties in Portugal through the Predimed network.",
      cta: "Visit Predimed.pt"
    },
    services: {
      title: "Services",
      subtitle: "Complete solutions for the real estate market",
      items: [
        {
          id: 1,
          title: "Property Purchase & Sale",
          description: "Selection of quality properties and personalized support throughout the entire process."
        },
        {
          id: 2,
          title: "Home Construction",
          description: "Personalized architectural projects and construction of houses with quality materials."
        },
        {
          id: 3,
          title: "Interior Design",
          description: "We transform spaces into unique and functional environments with specialized designers."
        },
        {
          id: 4,
          title: "Remodeling & Renovations",
          description: "Modernization and enhancement of properties with quality and attention to detail."
        },
        {
          id: 5,
          title: "Moving Management",
          description: "Complete moving and organization service to make your transition simple and efficient."
        },
        {
          id: 6,
          title: "Legal Consulting",
          description: "Partnership with law firms specialized in real estate law for total security."
        }
      ]
    },
    about: {
      title: "Who is Miguel Ângelo?",
      description: "Network manager with over 8 years of experience in the luxury real estate market. Specialized in premium properties, I offer personalized and exclusive service, connecting discerning clients to the best market opportunities.",
      experience: "Years of Experience",
      network: "National Network"
    },
    differentials: {
      title: "What Sets Me Apart",
      items: [
        {
          id: 1,
          title: "Predimed National Network",
          description: "Access to a wide network of properties and qualified buyers throughout the country through the Predimed network."
        },
        {
          id: 2,
          title: "Personalized Service",
          description: "Complete support from search to key delivery, including all complementary services."
        },
        {
          id: 3,
          title: "Professional Marketing",
          description: "Professional photography, videos, virtual tours and digital marketing campaigns to highlight your property."
        },
        {
          id: 4,
          title: "Proven Experience",
          description: "Over 8 years of experience in the real estate market with consistent results."
        },
        {
          id: 5,
          title: "Multidisciplinary Team",
          description: "Partnerships with reference architects, designers, lawyers and builders in the market."
        }
      ]
    },
    properties: {
      title: "Exclusive Properties",
      subtitle: "Premium selection of luxury properties",
      specialMessage: "Work with me, any property you like, even from other agencies, can be yours",
      viewAll: "View Complete Portfolio",
      bedrooms: "bedrooms",
      bathrooms: "bathrooms",
      area: "area",
      reference: "Ref"
    },
    featuredProperty: {
      badge: "FEATURED OPPORTUNITY",
      photos: "Photos",
      bedrooms: "Bedrooms",
      bathrooms: "Bathrooms",
      area: "sqm",
      equipment: "Equipment:",
      brutArea: "Gross Area:",
      landArea: "Land:",
      year: "Year:",
      energyCert: "Energy Certificate:",
      requestInfo: "Request Information",
      viewOnPredimed: "View on Predimed",
      viewFloorPlans: "View Floor Plans",
      makeOffer: "Make Offer",
      floorPlansTitle: "Property Floor Plans",
      floorPlansSubtitle: "Detailed technical plans of all floors",
      floorPlan: "Floor Plan",
      of: "of",
      offerModalTitle: "Make Offer",
      askingPrice: "Asking Price:",
      yourOffer: "Your Offer Amount",
      offerPlaceholder: "Enter your offer amount",
      offerAnalysis: "Offer Analysis",
      difference: "Difference",
      percentage: "Percentage",
      summary: "Summary",
      cancel: "Cancel",
      sendOffer: "Send Offer",
      disclaimer: "* Upon sending the offer, you will be redirected to the contact form where you can finalize the request.",
      offerTooLow: "Offer well below asking price. May not be considered.",
      offerLow: "Low offer. Requires significant negotiation.",
      offerReasonable: "Reasonable offer. Seller may negotiate.",
      offerExcellent: "Excellent offer! Very likely to be accepted."
    },
    contact: {
      title: "Let's Talk About Your Project?",
      subtitle: "Get in touch for a personalized consultation",
      phone: "Phone",
      email: "Email",
      location: "Location",
      form: {
        name: "Name",
        email: "Email",
        phone: "Phone",
        country: "Country",
        city: "City",
        interest: "Interest",
        buy: "BUY",
        sell: "SELL",
        message: "Message",
        submit: "Send Message",
        success: "Message sent successfully!",
        successDescription: "We will contact you soon!",
        error: "Error sending message. Please try again."
      }
    },
    footer: {
      description: "Network Manager specialized in real estate market focusing on quality properties.",
      contact: "Contact",
      properties: "Properties",
      viewAllPredimed: "View complete Predimed portfolio",
      accessInfo: "Access to +8000 properties in Portugal",
      designed: "Designed for Real Estate Market",
      rights: "All rights reserved"
    },
    simulator: {
      title: "Network Simulator",
      subtitle: "Calculate your potential annual earnings",
      login: {
        title: "Network Simulator",
        restrictedAccess: "Restricted Access",
        password: "Password",
        passwordPlaceholder: "Enter password",
        submit: "Access",
        errorMessage: "Incorrect password! Please try again."
      },
      config: {
        ownRevenue: "Your Annual Revenue",
        ownRevenueLabel: "Own Revenue (€/year)",
        ownRevenueHelper: "You earn 80% of this revenue",
        networkConfig: "Network Configuration",
        people: "People",
        peoplePerLine: "People per line",
        revenue: "Revenue (€)",
        level: "Level",
        commission: "commission",
        emptyLevel: "empty",
        uniformRevenue: "Uniform revenue for all",
        individualRevenue: "Individual revenue per person",
        person: "Person"
      },
      pyramid: {
        title: "Network Visualization",
        you: "YOU",
        youCommission: "80% commission",
        totalPeople: "Total People in Network",
        peopleInNetwork: "People in your network"
      },
      calculate: "Calculate Earnings",
      results: {
        title: "Total Annual Earnings",
        perYear: "Per year",
        perMonth: "/month",
        breakdown: "Breakdown",
        ownCommission: "Own Commission (80%)",
        networkCommissions: "Network Commissions:",
        networkTotal: "Network Total",
        networkSize: "Network Size",
        peopleCount: "people"
      }
    }
  },
  es: {
    nav: {
      home: "Inicio",
      team: "Equipo",
      services: "Servicios",
      contact: "Contacto",
      predimed: "Propiedades"
    },
    hero: {
      title: "Miguel Ângelo",
      subtitle: "Gestor de Red",
      description: "Especialista en gestión de redes y desarrollo de equipos, combinando estrategia, liderazgo e Inteligencia Artificial para acelerar el crecimiento y maximizar los resultados. Ayudo a personas y negocios a alcanzar su máximo potencial con un acompañamiento cercano y orientado al rendimiento.",
      cta: "Conocer al Equipo",
      contact: "Agendar Reunión"
    },
    apexTeam: {
      title: "Apex Team",
      subtitle: "El equipo de alto rendimiento a tu lado",
      description: "Profesionales dedicados a tu crecimiento. Estrategia, liderazgo y ejecución orientada a resultados.",
      roleLabel: "Rol",
      contactMember: "Contactar"
    },
    predimedInvite: {
      title: "¿Buscas propiedades?",
      description: "Accede a más de 8.000 inmuebles en Portugal a través de la red Predimed.",
      cta: "Visitar Predimed.pt"
    },
    services: {
      title: "Servicios",
      subtitle: "Soluciones completas para el mercado inmobiliario",
      items: [
        {
          id: 1,
          title: "Compra y Venta de Inmuebles",
          description: "Selección de propiedades de calidad y acompañamiento personalizado en todas las etapas del proceso."
        },
        {
          id: 2,
          title: "Construcción de Casas",
          description: "Proyectos arquitectónicos personalizados y construcción de viviendas con materiales de calidad."
        },
        {
          id: 3,
          title: "Diseño de Interiores",
          description: "Transformamos espacios en ambientes únicos y funcionales con diseñadores especializados."
        },
        {
          id: 4,
          title: "Remodelaciones y Renovaciones",
          description: "Modernización y valorización de propiedades con calidad y atención a los detalles."
        },
        {
          id: 5,
          title: "Gestión de Mudanzas",
          description: "Servicio completo de mudanza y organización para hacer su transición simple y eficiente."
        },
        {
          id: 6,
          title: "Consultoría Jurídica",
          description: "Asociación con bufetes de abogados especializados en derecho inmobiliario para total seguridad."
        }
      ]
    },
    about: {
      title: "¿Quién es Miguel Ângelo?",
      description: "Gestor de red con más de 8 años de experiencia en el mercado inmobiliario de lujo. Especializado en propiedades premium, ofrezco un servicio personalizado y exclusivo, conectando clientes exigentes con las mejores oportunidades del mercado.",
      experience: "Años de Experiencia",
      network: "Red Nacional"
    },
    differentials: {
      title: "Lo Que Me Distingue",
      items: [
        {
          id: 1,
          title: "Red Nacional Predimed",
          description: "Acceso a una amplia red de propiedades y compradores calificados en todo el país a través de la red Predimed."
        },
        {
          id: 2,
          title: "Servicio Personalizado",
          description: "Acompañamiento completo desde la búsqueda hasta la entrega de las llaves, incluyendo todos los servicios complementarios."
        },
        {
          id: 3,
          title: "Marketing Profesional",
          description: "Fotografía profesional, videos, tours virtuales y campañas de marketing digital para destacar su inmueble."
        },
        {
          id: 4,
          title: "Experiencia Comprobada",
          description: "Más de 8 años de experiencia en el mercado inmobiliario con resultados consistentes."
        },
        {
          id: 5,
          title: "Equipo Multidisciplinario",
          description: "Asociaciones con arquitectos, diseñadores, abogados y constructores de referencia en el mercado."
        }
      ]
    },
    properties: {
      title: "Propiedades Exclusivas",
      subtitle: "Selección premium de propiedades de lujo",
      specialMessage: "Trabajar conmigo, cualquier propiedad que le guste, incluso de otras agencias, puede ser suya",
      viewAll: "Ver Portafolio Completo",
      bedrooms: "dormitorios",
      bathrooms: "baños",
      area: "área",
      reference: "Ref"
    },
    featuredProperty: {
      badge: "OPORTUNIDAD DESTACADA",
      photos: "Fotos",
      bedrooms: "Dormitorios",
      bathrooms: "Baños",
      area: "m²",
      equipment: "Equipamiento:",
      brutArea: "Área Bruta:",
      landArea: "Terreno:",
      year: "Año:",
      energyCert: "Certificado Energético:",
      requestInfo: "Solicitar Información",
      viewOnPredimed: "Ver en Predimed",
      viewFloorPlans: "Ver Planos",
      makeOffer: "Hacer Oferta",
      floorPlansTitle: "Planos de la Propiedad",
      floorPlansSubtitle: "Planos técnicos detallados de todos los pisos",
      floorPlan: "Plano",
      of: "de",
      offerModalTitle: "Hacer Oferta",
      askingPrice: "Precio Pedido:",
      yourOffer: "Valor de Su Oferta",
      offerPlaceholder: "Ingrese el valor de su oferta",
      offerAnalysis: "Análisis de la Oferta",
      difference: "Diferencia",
      percentage: "Porcentaje",
      summary: "Resumen",
      cancel: "Cancelar",
      sendOffer: "Enviar Oferta",
      disclaimer: "* Al enviar la oferta, será redirigido al formulario de contacto donde podrá finalizar la solicitud.",
      offerTooLow: "Oferta muy por debajo del precio pedido. Puede no ser considerada.",
      offerLow: "Oferta baja. Requiere negociación significativa.",
      offerReasonable: "Oferta razonable. El vendedor puede negociar.",
      offerExcellent: "¡Excelente oferta! Muy probable que sea aceptada."
    },
    contact: {
      title: "¿Hablamos de Su Proyecto?",
      subtitle: "Póngase en contacto para una consulta personalizada",
      phone: "Teléfono",
      email: "Correo Electrónico",
      location: "Ubicación",
      form: {
        name: "Nombre",
        email: "Correo Electrónico",
        phone: "Teléfono",
        country: "País",
        city: "Ciudad",
        interest: "Interés",
        buy: "COMPRA",
        sell: "VENTA",
        message: "Mensaje",
        submit: "Enviar Mensaje",
        success: "¡Mensaje enviado con éxito!",
        successDescription: "¡Nos pondremos en contacto pronto!",
        error: "Error al enviar el mensaje. Inténtelo de nuevo."
      }
    },
    footer: {
      description: "Gestor de Red especializado en el mercado inmobiliario con enfoque en propiedades de calidad.",
      contact: "Contacto",
      properties: "Propiedades",
      viewAllPredimed: "Ver portafolio completo Predimed",
      accessInfo: "Acceso a +8000 propiedades en Portugal",
      designed: "Diseñado para el Mercado Inmobiliario",
      rights: "Todos los derechos reservados"
    },
    simulator: {
      title: "Simulador de Red",
      subtitle: "Calcule sus ganancias potenciales anuales",
      login: {
        title: "Simulador de Red",
        restrictedAccess: "Acceso Restringido",
        password: "Contraseña",
        passwordPlaceholder: "Ingrese la contraseña",
        submit: "Acceder",
        errorMessage: "¡Contraseña incorrecta! Intente nuevamente."
      },
      config: {
        ownRevenue: "Su Facturación Anual",
        ownRevenueLabel: "Facturación Propia (€/año)",
        ownRevenueHelper: "Usted gana 80% de esta facturación",
        networkConfig: "Configuración de la Red",
        people: "Personas",
        peoplePerLine: "Personas por línea",
        revenue: "Facturación (€)",
        level: "Nivel",
        commission: "comisión",
        emptyLevel: "vacío",
        uniformRevenue: "Facturación uniforme para todos",
        individualRevenue: "Facturación individual por persona",
        person: "Persona"
      },
      pyramid: {
        title: "Visualización de la Red",
        you: "USTED",
        youCommission: "80% comisión",
        totalPeople: "Total de Personas en la Red",
        peopleInNetwork: "Personas en su red"
      },
      calculate: "Calcular Ganancias",
      results: {
        title: "Ganancias Totales Anuales",
        perYear: "Por año",
        perMonth: "/mes",
        breakdown: "Desglose",
        ownCommission: "Comisión Propia (80%)",
        networkCommissions: "Comisiones de la Red:",
        networkTotal: "Total de la Red",
        networkSize: "Tamaño de la Red",
        peopleCount: "personas"
      }
    }
  },
  fr: {
    nav: {
      home: "Accueil",
      team: "Équipe",
      services: "Services",
      contact: "Contact",
      predimed: "Propriétés"
    },
    hero: {
      title: "Miguel Ângelo",
      subtitle: "Gestionnaire de Réseau",
      description: "Spécialiste en gestion de réseaux et développement d'équipes, combinant stratégie, leadership et Intelligence Artificielle pour accélérer la croissance et maximiser les résultats. J'aide les personnes et les entreprises à atteindre leur plein potentiel grâce à un accompagnement proche et axé sur la performance.",
      cta: "Découvrir l'Équipe",
      contact: "Planifier une Réunion"
    },
    apexTeam: {
      title: "Apex Team",
      subtitle: "L'équipe de haute performance à vos côtés",
      description: "Des professionnels dévoués à votre croissance. Stratégie, leadership et exécution axée sur les résultats.",
      roleLabel: "Rôle",
      contactMember: "Contacter"
    },
    predimedInvite: {
      title: "À la recherche de propriétés ?",
      description: "Accédez à plus de 8 000 biens immobiliers au Portugal via le réseau Predimed.",
      cta: "Visiter Predimed.pt"
    },
    services: {
      title: "Services Premium",
      subtitle: "Solutions complètes pour le marché immobilier de luxe",
      items: [
        {
          id: 1,
          title: "Achat & Vente de Propriétés",
          description: "Sélection de propriétés de qualité et accompagnement personnalisé à chaque étape du processus."
        },
        {
          id: 2,
          title: "Construction de Maisons",
          description: "Projets architecturaux personnalisés et construction de villas avec des matériaux de qualité."
        },
        {
          id: 3,
          title: "Design d'Intérieur",
          description: "Nous transformons les espaces en environnements uniques et fonctionnels avec des designers spécialisés."
        },
        {
          id: 4,
          title: "Rénovations & Modernisations",
          description: "Modernisation et valorisation des propriétés avec qualité et attention aux détails."
        },
        {
          id: 5,
          title: "Gestion de Déménagements",
          description: "Service complet de déménagement et organisation pour rendre votre transition simple et efficace."
        },
        {
          id: 6,
          title: "Conseil Juridique",
          description: "Partenariat avec des cabinets d'avocats spécialisés en droit immobilier pour une sécurité totale."
        }
      ]
    },
    about: {
      title: "Qui est Miguel Ângelo?",
      description: "Gestionnaire de réseau avec plus de 8 ans d'expérience sur le marché immobilier de luxe. Spécialisé dans les propriétés premium, j'offre un service personnalisé et exclusif, connectant des clients exigeants aux meilleures opportunités du marché.",
      experience: "Années d'Expérience",
      network: "Réseau National"
    },
    differentials: {
      title: "Excellence dans Chaque Détail",
      items: [
        {
          id: 1,
          title: "Réseau National",
          description: "Accès aux meilleures opportunités dans tout le pays.",
          icon: "🌍"
        },
        {
          id: 2,
          title: "Marché de Luxe",
          description: "Spécialiste de propriétés premium et exclusives.",
          icon: "💎"
        },
        {
          id: 3,
          title: "Accompagnement Personnalisé",
          description: "Service sur mesure pour clients exigeants.",
          icon: "🤝"
        },
        {
          id: 4,
          title: "Excellence Prouvée",
          description: "Plus de 8 ans d'expérience et résultats.",
          icon: "⭐"
        }
      ]
    },
    properties: {
      title: "Propriétés Exclusives",
      subtitle: "Sélection premium de propriétés de luxe",
      specialMessage: "Travailler avec moi, toute propriété que vous aimez, même d'autres agences, peut être la vôtre",
      viewAll: "Voir le Portfolio Complet",
      bedrooms: "chambres",
      bathrooms: "salles de bain",
      area: "superficie",
      reference: "Réf"
    },
    featuredProperty: {
      badge: "OPPORTUNITÉ EN VEDETTE",
      photos: "Photos",
      bedrooms: "Chambres",
      bathrooms: "Salles de bain",
      area: "m²",
      equipment: "Équipement:",
      brutArea: "Surface Brute:",
      landArea: "Terrain:",
      year: "Année:",
      energyCert: "Certificat Énergétique:",
      requestInfo: "Demander des Informations",
      viewOnPredimed: "Voir sur Predimed",
      viewFloorPlans: "Voir les Plans",
      makeOffer: "Faire une Offre",
      floorPlansTitle: "Plans de la Propriété",
      floorPlansSubtitle: "Plans techniques détaillés de tous les étages",
      floorPlan: "Plan",
      of: "de",
      offerModalTitle: "Faire une Offre",
      askingPrice: "Prix Demandé:",
      yourOffer: "Montant de Votre Offre",
      offerPlaceholder: "Entrez le montant de votre offre",
      offerAnalysis: "Analyse de l'Offre",
      difference: "Différence",
      percentage: "Pourcentage",
      summary: "Résumé",
      cancel: "Annuler",
      sendOffer: "Envoyer l'Offre",
      disclaimer: "* En envoyant l'offre, vous serez redirigé vers le formulaire de contact où vous pourrez finaliser la demande.",
      offerTooLow: "Offre bien en dessous du prix demandé. Peut ne pas être considérée.",
      offerLow: "Offre basse. Nécessite une négociation importante.",
      offerReasonable: "Offre raisonnable. Le vendeur peut négocier.",
      offerExcellent: "Excellente offre! Très probable d'être acceptée."
    },
    contact: {
      title: "Parlons de Votre Projet?",
      subtitle: "Contactez-nous pour une consultation personnalisée",
      phone: "Téléphone",
      email: "Email",
      location: "Localisation",
      form: {
        name: "Nom",
        email: "Email",
        phone: "Téléphone",
        country: "Pays",
        city: "Ville",
        interest: "Intérêt",
        buy: "ACHAT",
        sell: "VENTE",
        message: "Message",
        submit: "Envoyer le Message",
        success: "Message envoyé avec succès!",
        successDescription: "Nous vous recontacterons bientôt!",
        error: "Erreur lors de l'envoi du message. Veuillez réessayer."
      }
    },
    footer: {
      description: "Gestionnaire de réseau spécialisé dans le marché immobilier axé sur des propriétés de qualité.",
      contact: "Contact",
      properties: "Propriétés",
      viewAllPredimed: "Voir le portfolio complet Predimed",
      accessInfo: "Accès à +8000 propriétés au Portugal",
      designed: "Conçu pour le Marché Immobilier",
      rights: "Tous droits réservés"
    },
    simulator: {
      title: "Simulateur de Réseau",
      subtitle: "Calculez vos gains potentiels annuels",
      login: {
        title: "Simulateur de Réseau",
        restrictedAccess: "Accès Restreint",
        password: "Mot de passe",
        passwordPlaceholder: "Entrez le mot de passe",
        submit: "Accéder",
        errorMessage: "Mot de passe incorrect ! Veuillez réessayer."
      },
      config: {
        ownRevenue: "Votre Chiffre d'Affaires Annuel",
        ownRevenueLabel: "Chiffre d'Affaires Propre (€/an)",
        ownRevenueHelper: "Vous gagnez 80% de ce chiffre d'affaires",
        networkConfig: "Configuration du Réseau",
        people: "Personnes",
        peoplePerLine: "Personnes par ligne",
        revenue: "Chiffre d'Affaires (€)",
        level: "Niveau",
        commission: "commission",
        emptyLevel: "vide",
        uniformRevenue: "Chiffre d'affaires uniforme pour tous",
        individualRevenue: "Chiffre d'affaires individuel par personne",
        person: "Personne"
      },
      pyramid: {
        title: "Visualisation du Réseau",
        you: "VOUS",
        youCommission: "80% commission",
        totalPeople: "Total de Personnes dans le Réseau",
        peopleInNetwork: "Personnes dans votre réseau"
      },
      calculate: "Calculer les Gains",
      results: {
        title: "Gains Totaux Annuels",
        perYear: "Par an",
        perMonth: "/mois",
        breakdown: "Détails",
        ownCommission: "Commission Propre (80%)",
        networkCommissions: "Commissions du Réseau:",
        networkTotal: "Total du Réseau",
        networkSize: "Taille du Réseau",
        peopleCount: "personnes"
      }
    }
  },
  de: {
    nav: {
      home: "Startseite",
      team: "Team",
      services: "Dienstleistungen",
      contact: "Kontakt",
      predimed: "Immobilien"
    },
    hero: {
      title: "Miguel Ângelo",
      subtitle: "Netzwerkmanager",
      description: "Spezialist für Netzwerkmanagement und Teamentwicklung, der Strategie, Führung und Künstliche Intelligenz kombiniert, um Wachstum zu beschleunigen und Ergebnisse zu maximieren. Ich helfe Menschen und Unternehmen, ihr volles Potenzial durch enge und leistungsorientierte Begleitung zu erreichen.",
      cta: "Team Kennenlernen",
      contact: "Termin Vereinbaren"
    },
    apexTeam: {
      title: "Apex Team",
      subtitle: "Das Hochleistungsteam an Ihrer Seite",
      description: "Profis, die Ihrem Wachstum gewidmet sind. Strategie, Führung und ergebnisorientierte Umsetzung.",
      roleLabel: "Rolle",
      contactMember: "Kontaktieren"
    },
    predimedInvite: {
      title: "Suchen Sie Immobilien?",
      description: "Zugang zu über 8.000 Immobilien in Portugal über das Predimed-Netzwerk.",
      cta: "Predimed.pt besuchen"
    },
    services: {
      title: "Premium-Dienstleistungen",
      subtitle: "Komplette Lösungen für den Luxusimmobilienmarkt",
      items: [
        {
          id: 1,
          title: "Kauf & Verkauf von Immobilien",
          description: "Auswahl hochwertiger Immobilien und persönliche Begleitung in allen Phasen des Prozesses."
        },
        {
          id: 2,
          title: "Hausbau",
          description: "Maßgeschneiderte architektonische Projekte und Bau von Villen mit hochwertigen Materialien."
        },
        {
          id: 3,
          title: "Innenarchitektur",
          description: "Wir verwandeln Räume in einzigartige und funktionale Umgebungen mit spezialisierten Designern."
        },
        {
          id: 4,
          title: "Renovierungen & Modernisierungen",
          description: "Modernisierung und Wertsteigerung von Immobilien mit Qualität und Liebe zum Detail."
        },
        {
          id: 5,
          title: "Umzugsmanagement",
          description: "Kompletter Umzugs- und Organisationsservice, um Ihren Übergang einfach und effizient zu gestalten."
        },
        {
          id: 6,
          title: "Rechtsberatung",
          description: "Partnerschaft mit spezialisierten Anwaltskanzleien im Immobilienrecht für absolute Sicherheit."
        }
      ]
    },
    about: {
      title: "Wer ist Miguel Ângelo?",
      description: "Netzwerkmanager mit über 8 Jahren Erfahrung im Luxusimmobilienmarkt. Spezialisiert auf Premium-Immobilien biete ich personalisierten und exklusiven Service und verbinde anspruchsvolle Kunden mit den besten Marktchancen.",
      experience: "Jahre Erfahrung",
      network: "Nationales Netzwerk"
    },
    differentials: {
      title: "Exzellenz in Jedem Detail",
      items: [
        {
          id: 1,
          title: "Nationales Netzwerk",
          description: "Zugang zu den besten Möglichkeiten im ganzen Land.",
          icon: "🌍"
        },
        {
          id: 2,
          title: "Luxusmarkt",
          description: "Spezialist für Premium- und exklusive Immobilien.",
          icon: "💎"
        },
        {
          id: 3,
          title: "Persönliche Betreuung",
          description: "Maßgeschneiderter Service für anspruchsvolle Kunden.",
          icon: "🤝"
        },
        {
          id: 4,
          title: "Bewährte Exzellenz",
          description: "Über 8 Jahre Erfahrung und Ergebnisse.",
          icon: "⭐"
        }
      ]
    },
    properties: {
      title: "Exklusive Immobilien",
      subtitle: "Premium-Auswahl an Luxusimmobilien",
      specialMessage: "Arbeiten Sie mit mir, jede Immobilie, die Ihnen gefällt, auch von anderen Agenturen, kann Ihnen gehören",
      viewAll: "Vollständiges Portfolio Anzeigen",
      bedrooms: "Schlafzimmer",
      bathrooms: "Badezimmer",
      area: "Fläche",
      reference: "Ref"
    },
    featuredProperty: {
      badge: "EMPFOHLENE GELEGENHEIT",
      photos: "Fotos",
      bedrooms: "Schlafzimmer",
      bathrooms: "Badezimmer",
      area: "m²",
      equipment: "Ausstattung:",
      brutArea: "Bruttofläche:",
      landArea: "Grundstück:",
      year: "Jahr:",
      energyCert: "Energieausweis:",
      requestInfo: "Informationen Anfordern",
      viewOnPredimed: "Auf Predimed Anzeigen",
      viewFloorPlans: "Grundrisse Anzeigen",
      makeOffer: "Angebot Machen",
      floorPlansTitle: "Immobilien-Grundrisse",
      floorPlansSubtitle: "Detaillierte technische Pläne aller Etagen",
      floorPlan: "Grundriss",
      of: "von",
      offerModalTitle: "Angebot Machen",
      askingPrice: "Angebotspreis:",
      yourOffer: "Ihr Angebotsbetrag",
      offerPlaceholder: "Geben Sie Ihren Angebotsbetrag ein",
      offerAnalysis: "Angebotsanalyse",
      difference: "Unterschied",
      percentage: "Prozentsatz",
      summary: "Zusammenfassung",
      cancel: "Abbrechen",
      sendOffer: "Angebot Senden",
      disclaimer: "* Nach dem Absenden des Angebots werden Sie zum Kontaktformular weitergeleitet, wo Sie die Anfrage abschließen können.",
      offerTooLow: "Angebot weit unter dem Angebotspreis. Wird möglicherweise nicht berücksichtigt.",
      offerLow: "Niedriges Angebot. Erfordert erhebliche Verhandlungen.",
      offerReasonable: "Angemessenes Angebot. Verkäufer könnte verhandeln.",
      offerExcellent: "Ausgezeichnetes Angebot! Sehr wahrscheinlich angenommen zu werden."
    },
    contact: {
      title: "Sprechen Wir über Ihr Projekt?",
      subtitle: "Kontaktieren Sie uns für eine persönliche Beratung",
      phone: "Telefon",
      email: "E-Mail",
      location: "Standort",
      form: {
        name: "Name",
        email: "E-Mail",
        phone: "Telefon",
        country: "Land",
        city: "Stadt",
        interest: "Interesse",
        buy: "KAUF",
        sell: "VERKAUF",
        message: "Nachricht",
        submit: "Nachricht Senden",
        success: "Nachricht erfolgreich gesendet!",
        successDescription: "Wir werden uns bald bei Ihnen melden!",
        error: "Fehler beim Senden der Nachricht. Bitte versuchen Sie es erneut."
      }
    },
    footer: {
      description: "Netzwerkmanager spezialisiert auf den Immobilienmarkt mit Fokus auf Qualitätsimmobilien.",
      contact: "Kontakt",
      properties: "Immobilien",
      viewAllPredimed: "Vollständiges Predimed-Portfolio ansehen",
      accessInfo: "Zugang zu +8000 Immobilien in Portugal",
      designed: "Entwickelt für den Immobilienmarkt",
      rights: "Alle Rechte vorbehalten"
    },
    simulator: {
      title: "Netzwerk-Simulator",
      subtitle: "Berechnen Sie Ihre potenziellen Jahreseinnahmen",
      login: {
        title: "Netzwerk-Simulator",
        restrictedAccess: "Eingeschränkter Zugang",
        password: "Passwort",
        passwordPlaceholder: "Passwort eingeben",
        submit: "Zugreifen",
        errorMessage: "Falsches Passwort! Bitte versuchen Sie es erneut."
      },
      config: {
        ownRevenue: "Ihr Jahresumsatz",
        ownRevenueLabel: "Eigener Umsatz (€/Jahr)",
        ownRevenueHelper: "Sie verdienen 80% dieses Umsatzes",
        networkConfig: "Netzwerk-Konfiguration",
        people: "Personen",
        peoplePerLine: "Personen pro Linie",
        revenue: "Umsatz (€)",
        level: "Ebene",
        commission: "Provision",
        emptyLevel: "leer",
        uniformRevenue: "Einheitlicher Umsatz für alle",
        individualRevenue: "Individueller Umsatz pro Person",
        person: "Person"
      },
      pyramid: {
        title: "Netzwerk-Visualisierung",
        you: "SIE",
        youCommission: "80% Provision",
        totalPeople: "Gesamtzahl der Personen im Netzwerk",
        peopleInNetwork: "Personen in Ihrem Netzwerk"
      },
      calculate: "Einnahmen Berechnen",
      results: {
        title: "Gesamte Jahreseinnahmen",
        perYear: "Pro Jahr",
        perMonth: "/Monat",
        breakdown: "Aufschlüsselung",
        ownCommission: "Eigene Provision (80%)",
        networkCommissions: "Netzwerk-Provisionen:",
        networkTotal: "Netzwerk-Gesamt",
        networkSize: "Netzwerkgröße",
        peopleCount: "Personen"
      }
    }
  },
  ru: {
    nav: {
      home: "Главная",
      team: "Команда",
      services: "Услуги",
      contact: "Контакты",
      predimed: "Недвижимость"
    },
    hero: {
      title: "Мигель Анжелу",
      subtitle: "Менеджер Сети",
      description: "Специалист по управлению сетями и развитию команд, сочетающий стратегию, лидерство и искусственный интеллект для ускорения роста и максимизации результатов. Помогаю людям и бизнесу раскрыть максимальный потенциал через тесное сопровождение, ориентированное на результат.",
      cta: "Познакомиться с Командой",
      contact: "Запланировать Встречу"
    },
    apexTeam: {
      title: "Apex Team",
      subtitle: "Команда высокой производительности рядом с вами",
      description: "Профессионалы, преданные вашему росту. Стратегия, лидерство и ориентированное на результат исполнение.",
      roleLabel: "Роль",
      contactMember: "Связаться"
    },
    predimedInvite: {
      title: "Ищете недвижимость?",
      description: "Доступ к более чем 8000 объектов недвижимости в Португалии через сеть Predimed.",
      cta: "Посетить Predimed.pt"
    },
    services: {
      title: "Премиальные Услуги",
      subtitle: "Комплексные решения для рынка элитной недвижимости",
      items: [
        {
          id: 1,
          title: "Покупка и Продажа Недвижимости",
          description: "Отбор качественной недвижимости и персональное сопровождение на всех этапах процесса."
        },
        {
          id: 2,
          title: "Строительство Домов",
          description: "Индивидуальные архитектурные проекты и строительство вилл с использованием качественных материалов."
        },
        {
          id: 3,
          title: "Дизайн Интерьера",
          description: "Мы превращаем пространства в уникальные и функциональные среды с помощью специализированных дизайнеров."
        },
        {
          id: 4,
          title: "Ремонт и Модернизация",
          description: "Модернизация и повышение ценности недвижимости с качеством и вниманием к деталям."
        },
        {
          id: 5,
          title: "Управление Переездом",
          description: "Полный комплекс услуг по переезду и организации для простого и эффективного перехода."
        },
        {
          id: 6,
          title: "Юридическое Консультирование",
          description: "Партнерство со специализированными юридическими фирмами в сфере недвижимости для полной безопасности."
        }
      ]
    },
    about: {
      title: "Кто такой Мигель Анжелу?",
      description: "Менеджер сети с более чем 8-летним опытом работы на рынке элитной недвижимости. Специализируясь на премиальной недвижимости, я предлагаю персонализированное и эксклюзивное обслуживание, связывая взыскательных клиентов с лучшими рыночными возможностями.",
      experience: "Лет Опыта",
      network: "Национальная Сеть"
    },
    differentials: {
      title: "Совершенство в Каждой Детали",
      items: [
        {
          id: 1,
          title: "Национальная Сеть",
          description: "Доступ к лучшим возможностям по всей стране.",
          icon: "🌍"
        },
        {
          id: 2,
          title: "Элитный Рынок",
          description: "Специалист по премиальной и эксклюзивной недвижимости.",
          icon: "💎"
        },
        {
          id: 3,
          title: "Персональное Сопровождение",
          description: "Индивидуальный сервис для взыскательных клиентов.",
          icon: "🤝"
        },
        {
          id: 4,
          title: "Проверенное Совершенство",
          description: "Более 8 лет опыта и результатов.",
          icon: "⭐"
        }
      ]
    },
    properties: {
      title: "Эксклюзивная Недвижимость",
      subtitle: "Премиальная подборка элитной недвижимости",
      specialMessage: "Работая со мной, любая недвижимость, которая вам нравится, даже из других агентств, может стать вашей",
      viewAll: "Посмотреть Полное Портфолио",
      bedrooms: "спален",
      bathrooms: "ванных",
      area: "площадь",
      reference: "Реф"
    },
    featuredProperty: {
      badge: "РЕКОМЕНДУЕМАЯ ВОЗМОЖНОСТЬ",
      photos: "Фото",
      bedrooms: "Спальни",
      bathrooms: "Ванные",
      area: "м²",
      equipment: "Оборудование:",
      brutArea: "Общая Площадь:",
      landArea: "Участок:",
      year: "Год:",
      energyCert: "Энергетический Сертификат:",
      requestInfo: "Запросить Информацию",
      viewOnPredimed: "Посмотреть на Predimed",
      viewFloorPlans: "Посмотреть Планы",
      makeOffer: "Сделать Предложение",
      floorPlansTitle: "Планы Недвижимости",
      floorPlansSubtitle: "Детальные технические планы всех этажей",
      floorPlan: "План",
      of: "из",
      offerModalTitle: "Сделать Предложение",
      askingPrice: "Запрашиваемая Цена:",
      yourOffer: "Сумма Вашего Предложения",
      offerPlaceholder: "Введите сумму вашего предложения",
      offerAnalysis: "Анализ Предложения",
      difference: "Разница",
      percentage: "Процент",
      summary: "Резюме",
      cancel: "Отмена",
      sendOffer: "Отправить Предложение",
      disclaimer: "* После отправки предложения вы будете перенаправлены в контактную форму, где сможете завершить запрос.",
      offerTooLow: "Предложение намного ниже запрашиваемой цены. Может быть не рассмотрено.",
      offerLow: "Низкое предложение. Требует значительных переговоров.",
      offerReasonable: "Разумное предложение. Продавец может вести переговоры.",
      offerExcellent: "Отличное предложение! Очень вероятно будет принято."
    },
    contact: {
      title: "Давайте Обсудим Ваш Проект?",
      subtitle: "Свяжитесь с нами для персональной консультации",
      phone: "Телефон",
      email: "Электронная Почта",
      location: "Местоположение",
      form: {
        name: "Имя",
        email: "Электронная Почта",
        phone: "Телефон",
        country: "Страна",
        city: "Город",
        interest: "Интерес",
        buy: "ПОКУПКА",
        sell: "ПРОДАЖА",
        message: "Сообщение",
        submit: "Отправить Сообщение",
        success: "Сообщение успешно отправлено!",
        successDescription: "Мы свяжемся с вами в ближайшее время!",
        error: "Ошибка при отправке сообщения. Попробуйте еще раз."
      }
    },
    footer: {
      description: "Менеджер сети, специализирующийся на рынке недвижимости с акцентом на качественную недвижимость.",
      contact: "Контакты",
      properties: "Недвижимость",
      viewAllPredimed: "Посмотреть полное портфолио Predimed",
      accessInfo: "Доступ к +8000 объектам недвижимости в Португалии",
      designed: "Разработано для Рынка Недвижимости",
      rights: "Все права защищены"
    },
    simulator: {
      title: "Симулятор Сети",
      subtitle: "Рассчитайте свой потенциальный годовой доход",
      login: {
        title: "Симулятор Сети",
        restrictedAccess: "Ограниченный Доступ",
        password: "Пароль",
        passwordPlaceholder: "Введите пароль",
        submit: "Войти",
        errorMessage: "Неправильный пароль! Попробуйте снова."
      },
      config: {
        ownRevenue: "Ваш Годовой Доход",
        ownRevenueLabel: "Собственный Доход (€/год)",
        ownRevenueHelper: "Вы зарабатываете 80% этого дохода",
        networkConfig: "Конфигурация Сети",
        people: "Люди",
        peoplePerLine: "Человек на линию",
        revenue: "Доход (€)",
        level: "Уровень",
        commission: "комиссия",
        emptyLevel: "пусто",
        uniformRevenue: "Единый доход для всех",
        individualRevenue: "Индивидуальный доход на человека",
        person: "Человек"
      },
      pyramid: {
        title: "Визуализация Сети",
        you: "ВЫ",
        youCommission: "80% комиссия",
        totalPeople: "Всего Людей в Сети",
        peopleInNetwork: "Люди в вашей сети"
      },
      calculate: "Рассчитать Доход",
      results: {
        title: "Общий Годовой Доход",
        perYear: "В год",
        perMonth: "/месяц",
        breakdown: "Детализация",
        ownCommission: "Собственная Комиссия (80%)",
        networkCommissions: "Комиссии Сети:",
        networkTotal: "Общая Сеть",
        networkSize: "Размер Сети",
        peopleCount: "человек"
      }
    }
  },
  zh: {
    nav: {
      home: "首页",
      team: "团队",
      services: "服务",
      contact: "联系",
      predimed: "房产"
    },
    hero: {
      title: "米格尔·安杰洛",
      subtitle: "网络经理",
      description: "网络管理和团队发展专家，结合战略、领导力和人工智能来加速增长并最大化业绩。通过密切且以绩效为导向的指导，帮助人们和企业充分发挥潜力。",
      cta: "认识团队",
      contact: "安排会议"
    },
    apexTeam: {
      title: "Apex Team",
      subtitle: "与您并肩的高绩效团队",
      description: "致力于您成长的专业人士。战略、领导力和以结果为导向的执行力。",
      roleLabel: "角色",
      contactMember: "联系"
    },
    predimedInvite: {
      title: "在寻找房产吗？",
      description: "通过 Predimed 网络访问葡萄牙超过 8,000 处房产。",
      cta: "访问 Predimed.pt"
    },
    services: {
      title: "优质服务",
      subtitle: "豪华房地产市场的完整解决方案",
      items: [
        {
          id: 1,
          title: "房产买卖",
          description: "精选优质房产，全程提供个性化陪伴服务。"
        },
        {
          id: 2,
          title: "房屋建造",
          description: "定制建筑项目，使用优质材料建造别墅。"
        },
        {
          id: 3,
          title: "室内设计",
          description: "我们与专业设计师合作，将空间转变为独特且功能性的环境。"
        },
        {
          id: 4,
          title: "翻新与现代化",
          description: "以质量和对细节的关注实现房产的现代化和增值。"
        },
        {
          id: 5,
          title: "搬家管理",
          description: "全面的搬家和组织服务，让您的过渡简单高效。"
        },
        {
          id: 6,
          title: "法律咨询",
          description: "与专业房地产法律事务所合作，确保完全安全。"
        }
      ]
    },
    about: {
      title: "谁是米格尔·安杰洛？",
      description: "拥有超过8年豪华房地产市场经验的网络经理。专注于高端物业，提供个性化和独家服务，将挑剔的客户与最佳市场机会联系起来。",
      experience: "年经验",
      network: "全国网络"
    },
    differentials: {
      title: "每个细节都追求卓越",
      items: [
        {
          id: 1,
          title: "全国网络",
          description: "获得全国最佳机会。",
          icon: "🌍"
        },
        {
          id: 2,
          title: "豪华市场",
          description: "高端和独家房产专家。",
          icon: "💎"
        },
        {
          id: 3,
          title: "个性化陪伴",
          description: "为挑剔客户提供定制服务。",
          icon: "🤝"
        },
        {
          id: 4,
          title: "卓越成就",
          description: "超过8年的经验和成果。",
          icon: "⭐"
        }
      ]
    },
    properties: {
      title: "独家房产",
      subtitle: "豪华物业的优质精选",
      specialMessage: "与我合作，您喜欢的任何房产，即使来自其他中介，都可以成为您的",
      viewAll: "查看完整作品集",
      bedrooms: "卧室",
      bathrooms: "浴室",
      area: "面积",
      reference: "参考"
    },
    featuredProperty: {
      badge: "精选机会",
      photos: "照片",
      bedrooms: "卧室",
      bathrooms: "浴室",
      area: "平方米",
      equipment: "设备:",
      brutArea: "总面积:",
      landArea: "土地:",
      year: "年份:",
      energyCert: "能源证书:",
      requestInfo: "请求信息",
      viewOnPredimed: "在Predimed上查看",
      viewFloorPlans: "查看平面图",
      makeOffer: "提出报价",
      floorPlansTitle: "房产平面图",
      floorPlansSubtitle: "所有楼层的详细技术图纸",
      floorPlan: "平面图",
      of: "的",
      offerModalTitle: "提出报价",
      askingPrice: "要价:",
      yourOffer: "您的报价金额",
      offerPlaceholder: "输入您的报价金额",
      offerAnalysis: "报价分析",
      difference: "差额",
      percentage: "百分比",
      summary: "摘要",
      cancel: "取消",
      sendOffer: "发送报价",
      disclaimer: "* 发送报价后，您将被重定向到联系表格，您可以在那里完成请求。",
      offerTooLow: "报价远低于要价。可能不会被考虑。",
      offerLow: "低报价。需要进行重大谈判。",
      offerReasonable: "合理报价。卖方可能会谈判。",
      offerExcellent: "优秀报价！很有可能被接受。"
    },
    contact: {
      title: "让我们谈谈您的项目？",
      subtitle: "联系我们进行个性化咨询",
      phone: "电话",
      email: "电子邮件",
      location: "位置",
      form: {
        name: "姓名",
        email: "电子邮件",
        phone: "电话",
        country: "国家",
        city: "城市",
        interest: "兴趣",
        buy: "购买",
        sell: "出售",
        message: "消息",
        submit: "发送消息",
        success: "消息发送成功！",
        successDescription: "我们会尽快与您联系！",
        error: "发送消息时出错。请重试。"
      }
    },
    footer: {
      description: "专注于优质房产的房地产市场网络经理。",
      contact: "联系",
      properties: "房产",
      viewAllPredimed: "查看完整的Predimed作品集",
      accessInfo: "访问葡萄牙的+8000处房产",
      designed: "为房地产市场设计",
      rights: "版权所有"
    },
    simulator: {
      title: "网络模拟器",
      subtitle: "计算您的潜在年收入",
      login: {
        title: "网络模拟器",
        restrictedAccess: "受限访问",
        password: "密码",
        passwordPlaceholder: "输入密码",
        submit: "访问",
        errorMessage: "密码错误！请重试。"
      },
      config: {
        ownRevenue: "您的年收入",
        ownRevenueLabel: "自己的收入 (€/年)",
        ownRevenueHelper: "您赚取此收入的80%",
        networkConfig: "网络配置",
        people: "人",
        peoplePerLine: "每行人数",
        revenue: "收入 (€)",
        level: "级别",
        commission: "佣金",
        emptyLevel: "空",
        uniformRevenue: "所有人统一收入",
        individualRevenue: "每人个人收入",
        person: "人"
      },
      pyramid: {
        title: "网络可视化",
        you: "您",
        youCommission: "80% 佣金",
        totalPeople: "网络总人数",
        peopleInNetwork: "您网络中的人"
      },
      calculate: "计算收入",
      results: {
        title: "年总收入",
        perYear: "每年",
        perMonth: "/月",
        breakdown: "明细",
        ownCommission: "自己的佣金 (80%)",
        networkCommissions: "网络佣金:",
        networkTotal: "网络总计",
        networkSize: "网络规模",
        peopleCount: "人"
      }
    }
  }
};